module.exports = __webpack_public_path__ + "static/media/sai-teja.347d6722.png";